import React from "react";
import { Grid } from "@mui/material";
import { InstructionItemSchema } from "src/models/instruction/getInstruction";

interface ProductPageLayoutProps {
  instructionData?: InstructionItemSchema[] | null;
  nonPrescriptionDrug?: boolean;
  SideBar: JSX.Element;
}

const ProductPageLayout: React.FC<ProductPageLayoutProps> = ({
  SideBar,
  children,
}) => {
  return (
    <>
      <Grid position="relative" container maxWidth={1200} marginX="auto">
        <Grid item display={{ xs: "none", lg: "block" }} lg={3}>
          {SideBar}
        </Grid>
        <Grid item xs={12} lg={9}>
          {children}
        </Grid>
      </Grid>
    </>
  );
};

export default ProductPageLayout;
